import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMuteStyle0 = gravityIconIndividualCss;

const GravityIconMute = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e292468d403074bf110c8c66c17fb2b7208d8ce5', color: this.color, size: this.size }, h("svg", { key: 'ad553168f9fca140aef221868baaac71d99441c8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a9ceefce7a9f730cd5d21ce193d608b5966f947e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m13 9.94 6.65 6.65a.51.51 0 0 1 0 .71l-.35.35a.51.51 0 0 1-.71 0L4.32 3.38a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5 5 1.79-1.61a.5.5 0 0 1 .83.37v3.86ZM6.82 8.7l6 6a.46.46 0 0 1 .16.38v.78a.5.5 0 0 1-.83.37l-2.56-2.26H6.48a.5.5 0 0 1-.5-.5V9.05a.5.5 0 0 1 .5-.5.49.49 0 0 1 .34.15Z", fill: "currentColor" }))));
    }
};
GravityIconMute.style = GravityIconMuteStyle0;

export { GravityIconMute as gravity_icon_mute };

//# sourceMappingURL=gravity-icon-mute.entry.js.map